import * as React from "react";
import { SWRConfig } from "swr";

const swrConfig = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
};

export const AppSWRProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => (
    <SWRConfig value={swrConfig}>
        {children}
    </SWRConfig>
);

export default AppSWRProvider;
